import { COOKIES } from '#constants';

export function guid(): string {
  function s4(): string {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}

export function getDeviceUUID(): string {
  let target = getCookie(COOKIES.DEVICE_UUID_COOKIE_NAME);

  if (!target) {
    target = guid();

    setCookie(COOKIES.DEVICE_UUID_COOKIE_NAME, target, 90);
  }

  return target;
}

export function getCookie(cookieName: string): string {
  if (typeof window === 'undefined') {
    return '';
  }
  const name = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(window.document.cookie);

  const ca = decodedCookie.split(';');
  for (let c of ca) {
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function setCookie(
  cookieName: string,
  cookieValue: string,
  daysToExpire?: number,
) {
  if (typeof window === 'undefined') {
    return;
  }
  // If the cookie does not exist, create it
  const date = daysToExpire
    ? new Date(Date.now() + daysToExpire * 24 * 60 * 60 * 1000)
    : null;
  const expires = date ? `; expires=${date.toUTCString()}` : '';
  document.cookie = `${cookieName}=${cookieValue}${expires}; path=/`;
}
